/**
 * Created by Mikhail Menshenin on 07.04.2025
 */

var LastChanceWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.onSuccess = options.onSuccess || function () { };
        this.prolongation = options.prolongation;
        this.offer = options.offer;
        var styles = cleverapps.styles.LastChanceWindow;
        this._super({
            name: "lastchancewindow",
            title: Messages.get("LastChanceWindow.Title"),
            content: this.createContent(),
            styles: cleverapps.styles.LastChanceWindow.window,
            notCloseByTouchInShadow: true,
            button: {
                text: Messages.get(LastChanceWindow.PLAY_ON_MESSAGES[this.offer.type], this.offer),
                width: styles.button.width,
                height: styles.button.height,
                onPressed: this.onClick.bind(this)
            },
            openSound: bundles.lastchance_window.urls.continue_effect
        });

        if (this.offer.type === Product.TYPE_HARD) {
            cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
        }

        this.prolongation.on("acceptOffer", this.createListener(this.onAcceptOffer.bind(this), this));
    },

    createContent: function () {
        var animation = this.animation = new cleverapps.Spine(bundles.lastchance_window.jsons.lastchance_animation_json);
        var text = cleverapps.UI.generateOnlyText(Messages.get("LastChanceWindow.Text"), cleverapps.styles.FONTS.WINDOW_TEXT);

        return new cleverapps.Layout([animation, text], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.LastChanceWindow.margin
        });
    },

    onShow: function () {
        this._super();

        this.animation.setAnimationAndIdleAfter("open", "idle");
    },

    getPerson: function () {
        if (cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL) {
            return {
                role: "hero",
                emotion: "sad"
            };
        }
    },

    onClick: function () {
        this.prolongation.acceptOffer(this.offer);
    },

    onAcceptOffer: function () {
        this.onSuccess();
        this.close();
    },

    listBundles: function () {
        return ["lastchance_window"];
    }
});

cleverapps.styles.LastChanceWindow = {
    margin: 60,

    window: {
        padding: {
            x: 160
        }
    },

    button: {
        width: 420,
        height: 105
    }
};

LastChanceWindow.PLAY_ON_MESSAGES = {
    [Product.TYPE_FREE]: "LastChanceWindow.playOnFree",
    [Product.TYPE_ADS]: "LastChanceWindow.playOnAds",
    [Product.TYPE_HARD]: "LastChanceWindow.playOn"
};